import React, { useEffect } from "react";
import { LoginContextData } from "../Declarations";
import { useQuery } from "@tanstack/react-query";
import { createAxiosClient } from "@ntg/component-library/utilities";

interface ICheckPasswordResetRequiredProps {
    data: LoginContextData;
    onDecision: (requiresReset: boolean) => void;
}

export const CheckPasswordResetRequired = ({ data, onDecision }: ICheckPasswordResetRequiredProps) => {
    const axiosAuth = createAxiosClient("Auth");

    const query = useQuery({
        enabled:
            data.UserName !== undefined &&
            data.Password !== undefined &&
            data.UserID !== undefined &&
            data.BrowserFingerprint !== undefined,
        queryFn: async (): Promise<boolean> => {
            const res = await axiosAuth.post<boolean>(
                "/UILogin/RequiresPasswordReset",
                {
                    BrowserFingerPrint: data.BrowserFingerprint,
                    Password: data.Password,
                    UserAgent: navigator.userAgent,
                    UserID: data.UserID,
                    UserName: data.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data;
        },
        queryKey: [
            "checkPasswordReset",
            data.UserName,
            data.Password,
            data.UserID,
            data.BrowserFingerprint,
        ],
    });

    useEffect(() => {
        if (query.isSuccess) {
            onDecision(query.data);
        }
    }, [query.isSuccess, query.data, onDecision]);

    if (query.isLoading) {
        return <p>Checking if password reset is required...</p>;
    }

    if (query.isError) {
        return <p className="error">Unable to determine password reset status.</p>;
    }

    return null;
};
